import React, { type ReactNode } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import { offset, useFloating, shift } from '@floating-ui/react-dom';
import useToggle from '@hooks/useToggle';

interface Props {
  className?: string;
  text?: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  offsetVal?: number;
  size?: 'sm' | 'md';
  multiline?: boolean;
  children: ReactNode;
}

export function TipWrapper({
  className,
  children,
  text,
  placement = 'top',
  size = 'md',
  multiline = false,
  offsetVal = 10,
}: Props) {
  const { x, y, reference, floating, strategy } = useFloating({
    placement,
    middleware: [offset(offsetVal), shift()],
    strategy: 'fixed',
  });
  const show = useToggle(false);
  return (
    <>
      <div
        className={className}
        ref={reference}
        onMouseEnter={show.on}
        onMouseLeave={show.off}
      >
        {children}
      </div>
      {show.isOn &&
        !!text &&
        ReactDOM.createPortal(
          <div
            ref={floating}
            className={classNames(
              'flex items-center rounded bg-black-black bg-opacity-50 p-[6px] text-white',
              {
                'text-sm': size === 'sm',
                'text-base': size === 'md',
                'whitespace-nowrap': !multiline,
                'max-w-[250px]': multiline,
              }
            )}
            style={{
              position: strategy,
              top: y ?? '',
              left: x ?? '',
              zIndex: 12000,
            }}
          >
            {text}
          </div>,
          document.body
        )}
    </>
  );
}
